import React from "react";
import ContactBar from "../common/header/contact-bar";
import "./contact.css";

const Contact = () => {
  return (
    <>
      <h3>Contact Info</h3>
      <div className="contact-list">
        <ContactBar />
      </div>
    </>
  );
};

export default Contact;
